// Permission checker class and helpers
// Centralize role ranking and permission checks so other modules (Sidebar, routes) can reuse the logic.

const ROLE_RANK = {
  forecaster: 1,
  market_owner_read: 2,
  market_owner: 3,
  admin: 4,
};

export default class PermissionChecker {
  constructor({ isAdmin = false, isMarketOwner = false, isMarketOwnerReadOnly = false, isForecaster = false } = {}) {
    this.isAdmin = !!isAdmin;
    this.isMarketOwner = !!isMarketOwner;
    this.isMarketOwnerReadOnly = !!isMarketOwnerReadOnly;
    this.isForecaster = !!isForecaster;
    this.userRank = this.computeRank();
  }

  computeRank() {
    if (this.isAdmin) return ROLE_RANK.admin;
    if (this.isMarketOwner) return ROLE_RANK.market_owner;
    if (this.isMarketOwnerReadOnly) return ROLE_RANK.market_owner_read;
    if (this.isForecaster) return ROLE_RANK.forecaster;
    return 0;
  }

  // Check a single permission name (string)
  static rankOf(roleName) {
    return ROLE_RANK[roleName] || 0;
  }

  // Check whether a user's rank satisfies a required permission (string or array)
  satisfies(requiredPermission) {
    if (!requiredPermission) return true;

    const checkOne = (perm) => {
      const requiredRank = PermissionChecker.rankOf(perm);
      if (!requiredRank) return false; // unknown permission
      return this.userRank >= requiredRank;
    };

    if (Array.isArray(requiredPermission)) {
      return requiredPermission.some(checkOne);
    }

    return checkOne(requiredPermission);
  }

  // Convenience: check an `item` object with the optional ` requiredPermission ` field
  allows(item) {
    const req = item?.requiredPermission;
    return this.satisfies(req);
  }
}

